import ArchiveListBatchRestoreModal from './ArchiveListBatchRestoreModal'

export default ArchiveListBatchRestoreModal
